import { Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { ProblemEditor } from './pages/ProblemEditor';
import { AssessmentRunner } from './pages/AssessmentRunner';
import { WorkspaceSettings } from './pages/admin/WorkspaceSettings';
import { MembersManagement } from './pages/admin/MembersManagement';
import { AssessmentManagement } from './pages/admin/AssessmentManagement';
import { AssignmentManagement } from './pages/admin/AssignmentManagement';
import { LiveMonitoring } from './pages/admin/LiveMonitoring';
import { ProblemManagement } from './pages/admin/ProblemManagement';
import { Billing } from './pages/admin/Billing';
import { OrganizationWorkspaces } from './pages/admin/OrganizationWorkspaces';
import { NotFound } from './pages/NotFound';
import { Unauthorized } from './pages/Unauthorized';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/problems/:problemId" element={<ProblemEditor />} />
      <Route path="/assessments/:assignmentId" element={<AssessmentRunner />} />
      
      {/* Workspace Admin Routes */}
      <Route path="/w/:workspaceSlug/admin/settings" element={<WorkspaceSettings />} />
      <Route path="/w/:workspaceSlug/admin/members" element={<MembersManagement />} />
      <Route path="/w/:workspaceSlug/admin/problems" element={<ProblemManagement />} />
      <Route path="/w/:workspaceSlug/admin/assessments" element={<AssessmentManagement />} />
      <Route path="/w/:workspaceSlug/admin/assignments" element={<AssignmentManagement />} />
      <Route path="/w/:workspaceSlug/admin/monitoring" element={<LiveMonitoring />} />

      {/* Organization Admin Routes */}
      <Route path="/org/:orgSlug/admin/billing" element={<Billing />} />
      <Route path="/org/:orgSlug/admin/workspaces" element={<OrganizationWorkspaces />} />

      {/* Error Pages */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}


export default App;
